// Respaldo del catálogo de sustancias peligrosas (hazardous_substances_catalog) para cuando
// no hay señal de internet y GET /hazardous-substances-catalog no se puede completar. El
// catálogo real sigue siendo la fuente de verdad -- esto solo evita que el selector de
// "Sustancias Peligrosas Presentes" quede vacío/roto en campo sin conexión. Snapshot de los
// nombres activos en V22__create_hazardous_substances_catalog.sql -- si el catálogo cambia
// (se agrega/desactiva una sustancia), este archivo hay que actualizarlo a mano y redeployar
// el frontend (decisión de Omar: el catálogo "difícilmente cambiará", así que este desfase se
// controla operativamente, no con sincronización automática).
export const HAZARDOUS_SUBSTANCES_FALLBACK = [
  'Ninguna',
  'Gas LP',
  'Gasolina',
  'Diesel',
  'Aceite combustible',
  'Solventes',
  'Thinner',
  'Acetona',
  'Alcohol etílico',
  'Alcohol isopropílico',
  'Pinturas y barnices',
  'Resinas',
  'Ácido sulfúrico',
  'Ácido clorhídrico',
  'Ácido nítrico',
  'Hidróxido de sodio',
  'Hidróxido de potasio',
  'Cloro',
  'Amoniaco',
  'Formaldehído',
  'Benceno',
  'Tolueno',
  'Xileno',
  'Plaguicidas',
  'Herbicidas',
  'Peróxido de hidrógeno',
  'Oxígeno comprimido',
  'Nitrógeno líquido',
  'Propano',
  'Butano',
  'Metano',
  'Acetileno',
  'Materiales radiactivos',
  'Asbesto',
  'Mercurio',
  'Plomo',
  'Arsénico',
  'Cianuro',
  'Monóxido de carbono',
  'Dióxido de azufre'
];

// Forma esperada por el <TextField select> de EvaluacionInspeccionCompleta.jsx
// (hazardousSubstancesCatalog.map(sub => ({ id, name }))) -- id negativo para no chocar nunca
// con ids reales del catálogo del servidor.
export const buildHazardousSubstancesCatalogFallback = () =>
  HAZARDOUS_SUBSTANCES_FALLBACK.map((name, index) => ({ id: -1 - index, name }));
